module.exports = __webpack_public_path__ + "static/media/traffic.c03e80c8.svg";